import axios from 'axios';
import {
  FUNLIDAY_HOST_URL,
  JOURNAL_HOST_URL,
  X_FUNLIDAY_HEADERS,
  EC_HOST_URL,
} from './main';

const config = {
  headers: X_FUNLIDAY_HEADERS,
};

/** @method getTripInvitationLinkDescription: 取得給 invitationLink 的 meta-data <head> 內的各種 og 資訊、以及錯誤連結是否轉 404
 * @param {string} tripID (Required)該行程ID
 * @param {string} invitationID (Required)分享ID
 * @param {string} secretID (Required)定義在 .env 內的變數字串
 * @returns {Promise} axiosPromise
 */
export const getTripInvitationLinkDescription = (
  tripID,
  invitationID,
  secretID,
) => {
  const params = {
    tripId: tripID,
    invitationId: invitationID,
    secretId: secretID,
  };

  return axios.post(
    `${FUNLIDAY_HOST_URL}getTripInvitationLinkDescription`,
    params,
    config,
  );
};

/** @method getItineraryDescription: 取得給 Itinerary 的 meta-data <head> 內的各種 og 資訊、以及錯誤連結是否轉 404
 * @returns {Promise} axiosPromise
 */
export const getItineraryDescription = ({
  userid,
  parseTripObjectId,
  secretId,
  language,
}) => {
  const params = {
    secretId,
    parseTripObjectId,
    language,
  };

  if (userid) {
    params.userid = userid;
  }

  return axios.post(`${FUNLIDAY_HOST_URL}getTripDescription`, params, config);
};

/** @method getProfileDescription: 取得給 Profile 的 meta-data <head> 內的各種 og 資訊、以及錯誤連結是否轉 404
 * @param {string} userID (Required)網址上的 userID，以此去索取該 user 資料
 * @param {string} secretID (Required)環境變數 SECRET_ID_FOR_META_TAGS
 * @returns {Promise} axiosPromise
 */
export const getProfileDescription = (userID, secretID) => {
  const params = {
    userid: userID,
    secretId: secretID,
  };

  return axios.post(`${FUNLIDAY_HOST_URL}personal/get_profile`, params, config);
};

/** @method getJournalDescription: 取得給 Journal 的 meta-data <head> 內的各種 og 資訊、以及錯誤連結是否轉 404
 * @param {string} userID (Required)網址上的 userID，以此去索取該 Journal 資料
 * @param {string} journalID (Required)網址上的 journalID，以此去索取該 Journal 資料
 * @param {string} secretID (Required)環境變數 SECRET_ID_FOR_META_TAGS
 * @returns {Promise} axiosPromise
 */
export const getJournalDescription = (userID, journalID, secretID) => {
  const url = `${JOURNAL_HOST_URL}journals/${userID}/${journalID}?fields=meta&secret_id=${secretID}`;

  return axios.get(url, config);
};

/** @method getCollectionDescription: 取得給 Collection 的 meta-data <head> 內的各種 og 資訊、以及錯誤連結是否轉 404
 * @param {string} userID (Required)網址上的 userID，以此去索取該 Collection 資料
 * @param {string} collectionID (Required)網址上的 collectionID，以此去索取該 Collection 資料
 * @param {string} secretID (Required)環境變數 SECRET_ID_FOR_META_TAGS
 * @returns {Promise} axiosPromise
 */
export const getCollectionDescription = (userID, collectionID, secretID) => {
  const params = {
    secretId: secretID,
    id: collectionID,
    userid: userID,
  };
  return axios.post(
    `${FUNLIDAY_HOST_URL}getCollectionsFolderDescription`,
    params,
    config,
  );
};

/** @method getArticleDescription: 取得給 Article 的 meta-data <head> 內的各種 og 資訊、以及錯誤連結是否轉 404
 * @param {string} userID (Required)網址上的 userID，以此去索取該 Article 資料
 * @param {string} ArticleID (Required)網址上的 articleID，以此去索取該 Article 資料
 * @param {string} secretID (Required)環境變數 SECRET_ID_FOR_META_TAGS
 * @returns {Promise} axiosPromise
 */
export const getArticleDescription = (userID, ArticleID, secretID) => {
  const url = `${JOURNAL_HOST_URL}articles/${userID}/${ArticleID}?fields=meta&secret_id=${secretID}`;
  return axios.get(url, config);
};

/** @method getProductDescription: 取得給 Product 的 meta-data <head> 內的各種 og 資訊、以及錯誤連結是否轉 404
 * @param {string} userID (Required)網址上的 userID，以此去索取該 product 資料
 * @param {string} productID (Required)網址上的 productID，以此去索取該 product 資料
 * @param {string} secretID (Required)環境變數 SECRET_ID_FOR_META_TAGS
 * @returns {Promise} axiosPromise
 */
export const getProductDescription = (userID, productID, secretID) => {
  const url = `${EC_HOST_URL}products/${userID}/${productID}?fields=meta&secret_id=${secretID}`;
  return axios.get(url, config);
};
